<template>
    <div class='body-box marginBox'>
        <!-- 搜索与添加区域 -->
        <el-row class="plan selectBox" :gutter="24">
            <el-col :span='4'>
                <el-button @click='collateCoupon("batch")'>批量消券</el-button>
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.userName" placeholder="请输入使用人搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.couponIDName" placeholder="请输入优惠券名称/使用ID搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.couponPrice" type="number" placeholder="请输入优惠券面额搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <el-date-picker
                        v-model="search.endTime"
                        placeholder="优惠券截止日期"
                        type="datetime"
                        value-format="timestamp"
                        @change="handleQuery"
                ></el-date-picker>
            </el-col>

            <el-col :span='4'>
                <el-select v-model="search.type" clearable placeholder="选择优惠券状态进行筛选" @change="handleQuery">
                    <el-option
                            v-for="item in enumTypes"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-table :height="'calc(100% - 75px)'" :data='couponList' class='button-box' render ref="couponUseList">
            <el-table-column
                    type="selection"
                    width="45">
            </el-table-column>
          <el-table-column label='使用人' prop='userName'>
            <template slot-scope="scope">
<!--              {{scope.row.userName}}-->
              <span>{{scope.row.userBrief}}</span>
            </template>
          </el-table-column>
            <el-table-column label='优惠券使用ID' prop='id' />
            <el-table-column label='优惠券名称' prop='couponName' />
            <el-table-column label='适用产品' prop='applicableProduct'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.applicableProduct)}}
                </template>
            </el-table-column>
            <el-table-column label='优惠券面额' prop='couponPrice'/>
            <el-table-column label='适用有效期' prop='endTime'>
                <template slot-scope="scope">
                    {{scope.row.endTime | formatDate}}
                </template>
            </el-table-column>
            <el-table-column label='使用记录' prop='useRecord' />
            <el-table-column label='状态' prop='type'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.type)}}
                </template>
            </el-table-column>
            <el-table-column label='操作'>
                <template slot-scope="scope">
                    <el-button @click='collateCoupon(scope.row)'>消券</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getCouponUseList' /></div>
        <eliminate-dialog ref="eliminateCoupon" @refresh-list="handleQuery"></eliminate-dialog>
    </div>
</template>

<script>

  import SearchInput from '@/components/common/searchInput/searchInput'
  import Pagination from '@/components/common/Pagination/index'
  import EliminateDialog from '@/views/coupon/eliminateDialog'
  import { selectCouponUse, collateCoupon } from '@/api/coupon/coupon'
  import { formatDate } from '@/js/momen'
  import { alert, tips, deleteTips } from '@/utils/tips'
  import { enumStatus, enumTypes } from '@/js/enum'

  export default {
    name: 'userCoupon',
    components: { SearchInput, Pagination, EliminateDialog },
    data() {
      return {
        // 查询参数
        queryInfo: {
          current: 1,
          size: 10,
          price: '',
          type: ''
        },
        search: {},
        couponList: [],
        enumTypes
      }
    },
    created() {
      this.handleQuery()
    },
    mounted() {
    },
    methods: {
      // 消券
      collateCoupon(row) {
        let couponUses = []
        if (row !== "batch") {
          couponUses= [row]
        } else {
          couponUses = this.$refs.couponUseList.selection
        }
        if (couponUses.length === 0) {
          alert("请至少选择一行！")
          return
        }
        let noCoupon = couponUses.filter(res => res.type === 'UNCLAIMED' || res.type === 'CLAIMED').map(res => res.id)
        if (noCoupon.length > 0) {
          deleteTips("使用号为" + noCoupon.join(",") + "的优惠券用户未领取或者未在小程序中使用，确认要消除吗？").then(res => {
            if (res) {
              this.$refs.eliminateCoupon.showDialog(couponUses)
            }
          })
        } else {
          this.$refs.eliminateCoupon.showDialog(couponUses)
        }
      },
      // 状态码转换
      statusChange(p){
        let text = ''
        enumStatus.forEach(res => {
          if (p === res.key) {
            text = res.value
          }
        })
        return text
      },
      handleQuery() {
        this.$nextTick(() => {
          this.$refs.page.run()
        })
      },
      // 查看优惠券
      getCouponUseList(data,cb) {
        selectCouponUse(data, this.search).then(res => {
          this.couponList = cb(res)
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>